export class NotFoundError extends Error {
  readonly type: string;
  constructor() {
    super('Entry was not found.');
    this.type = 'NotFoundError';
  }
}
